import React from "react";
import { Link, withRouter } from "react-router-dom";
import logo from '../images/sac-logo-2a.png';
import { Navbar, Nav } from "react-bootstrap";

function Navigation(props) {
  return (
    <div className="navigation sticky-top">
<Navbar className="navbar"  variant="dark" expand="lg">
  <div className="container-fluid">

    <Navbar.Brand href="/"> 
            <img className="d-inline nav-logo" alt="Student Athlete Camps Logo" src={logo} />
            <div className="d-inline d-md-none ml-3">
              <div className=" logo-text-primary-sm d-inline">STUDENT</div>
              <div className=" pt-3  logo-text-secondary-sm d-inline">ATHLETE</div>
              <div className=" pt-3  logo-text-primary-sm d-inline">CAMPS</div>
            </div>
            <div className="d-sm-none d-none d-md-inline ml-3">
              <div className=" logo-text-primary d-inline">STUDENT</div>
              <div className=" pt-3  logo-text-secondary d-inline">ATHLETE</div>
              <div className=" pt-3  logo-text-primary d-inline">CAMPS</div>
            </div>
          </Navbar.Brand>
    <Navbar.Toggle className="white" aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
      <Nav className="me-auto">
        <Nav.Link href="/" className={`nav-item  ${props.location.pathname === "/" ? "active" : ""}`}>       
                <Link className="nav-link white" to="/">
                  Home
                </Link>
              </Nav.Link>

              <Nav.Link href="/events" className={`nav-item  ${props.location.pathname === "/events" ? "active" : ""}`}>       
              <Link className="nav-link white" to="/events">
                  Events
                </Link>
              </Nav.Link>

              <Nav.Link href="/contact" className={`nav-item  ${props.location.pathname === "/contact" ? "active" : ""}`}>       
              <Link className="nav-link white" to="/contact">
                  Contact
                </Link>
              </Nav.Link>

              <Nav.Link href="/about" className={`nav-item  ${props.location.pathname === "/about" ? "active" : ""}`}>       
              <Link className="nav-link white" to="/about">
                  About
                </Link>
              </Nav.Link>


      </Nav>
    </Navbar.Collapse>
    </div>
</Navbar>
    </div>
  );
}

export default withRouter(Navigation);

